module.exports = __webpack_public_path__ + "static/parade-2019-house11-cb9fcdfe77440ee02163743d5200d737.jpg";